import { render } from "./ApplicationList.vue?vue&type=template&id=71ad570c&scoped=true"
import script from "./ApplicationList.vue?vue&type=script&lang=js"
export * from "./ApplicationList.vue?vue&type=script&lang=js"

import "./ApplicationList.vue?vue&type=style&index=0&id=71ad570c&lang=less&scoped=true"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ad570c"]])

export default __exports__